import React, { Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';

//CSS
import '../../LandingSubcomponents/Servicios.css';

//Images
import chango from '../../../../assets/img/whatsapp-people.png';
import whats from '../../../../assets/img/servicios/compra-online/chango.png';

class PedidosOnline extends Component {
    render() {

        return (
            <div>
                <Row className="pedidos-online" style={{ paddingBottom: "20px" }}>
                    <Col md={7} mdOffset={1} sm={10} smOffset={1} xs={10} xsOffset={1}
                        className="wow animated bounceInLeft"
                        data-wow-duration="1.5s" data-wow-delay=".2s"
                    >
                        <h3>
                            Realizá tus pedidos On-Line
                        </h3>
                        <h4 style={{ fontSize: "15px" }}>
                            Seguí los siguientes pasos para disfrutar nuestros servicios de la mejor manera y recibí tu
                            mercadería en la puerta de tu negocio sin moverte de él.
                        </h4>


                        <Col lgHidden mdHidden sm={12} className="pedidos-online-mini">
                            <div>
                                <h5>
                                    1
                                </h5>
                                <p>
                                    Registrate ingresando al siguiente <a
                                        href="https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/">Link</a>
                                </p>
                            </div>
                            <div>
                                <h5>
                                    2
                                </h5>
                                <p>
                                    Recibirás un email para confirmar tu usuario.
                                </p>
                            </div>
                            <div>
                                <h5>
                                    3
                                </h5>
                                <p>
                                    Ingresá al e-commerce con los datos brindados.
                                </p>
                            </div>
                            <div>
                                <h5>
                                    4
                                </h5>
                                <p>
                                    Realizá tu pedido en cualquier momento del día desde donde quieras al mejor
                                    precio.
                                </p>
                            </div>
                            <div>
                                <h5>
                                    5
                                </h5>
                                <p>
                                    Recibí tu pedido en 24hs sin salir de tu negocio.
                                </p>
                            </div>
                            <div>
                                <a href="https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/" target="_blank">
                                    <Button className="btn-primary">
                                        Registrate
                                    </Button>
                                </a>
                            </div>
                            <Col xsHidden className="wow animated bounceInRight" data-wow-duration="1.5s"
                                data-wow-delay=".5s">
                                <img className="img-responsive" src={chango} alt="chango-supermercado" />
                            </Col>
                        </Col>


                        <Row style={{ marginTop: "30px" }}>
                            <Col md={6} smHidden xsHidden>
                                <Row style={{ marginBottom: "23px" }}>
                                    <Col md={2}>
                                        <h5>
                                            1
                                        </h5>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Registrate ingresando al siguiente <a
                                                href="https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/">Link</a>
                                        </p>
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: "23px" }}>
                                    <Col md={2}>
                                        <h5>
                                            2
                                        </h5>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Recibirás un email para confirmar tu usuario.
                                        </p>
                                    </Col>
                                </Row>
                                <Row style={{ marginBottom: "23px" }}>
                                    <Col md={2}>
                                        <h5>
                                            3
                                        </h5>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Ingresá al e-commerce con los datos brindados.
                                        </p>
                                    </Col>
                                </Row>
                            </Col>
                            <Col md={6} smHidden xsHidden>
                                <Row style={{ marginBottom: "5px" }}>
                                    <Col md={2}>
                                        <h5>
                                            4
                                        </h5>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Realizá tu pedido en cualquier momento del día desde donde quieras al mejor
                                            precio.
                                        </p>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={2}>
                                        <h5>
                                            5
                                        </h5>
                                    </Col>
                                    <Col md={10}>
                                        <p>
                                            Recibí tu pedido en 24hs sin salir de tu negocio.
                                        </p>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} mdOffset={6} smHidden xsHidden>
                                <a href="https://secure.sig2k.com/webs/myfsrl@sigma.defaultKart/sigkart/3.1/" target="_blank">
                                    <Button className="btn-primary">
                                        Registrate
                                    </Button>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={4} smHidden xsHidden className="wow animated bounceInRight" data-wow-duration="1.5s"
                        data-wow-delay=".5s">
                        <img className="img-responsive" src={whats} alt="chango-supermercado" />
                    </Col>
                </Row>
            </div>

        );
    }
}


export default PedidosOnline;


// WEBPACK FOOTER //
// ./src/pages/LandingPage/LandingSubcomponents/Servicios/PedidosOnline.js